import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const cookieAuthInterceptorInterceptor: HttpInterceptorFn = (
  req,
  next,
) => {
  // Only modify requests to the API
  const isApiUrl = req.url.startsWith(environment.apiUrl);

  if (isApiUrl) {
    // Clone the request to add withCredentials
    const authReq = req.clone({
      withCredentials: true,
    });
    return next(authReq);
  }

  return next(req);
};
